import { render, staticRenderFns } from "./participantInscription.view.vue?vue&type=template&id=076c0a61&scoped=true&lang=pug"
import script from "./participantInscription.view.vue?vue&type=script&lang=ts"
export * from "./participantInscription.view.vue?vue&type=script&lang=ts"
import style0 from "./participantInscription.view.vue?vue&type=style&index=0&id=076c0a61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c0a61",
  null
  
)

export default component.exports